import leurovisiu from './images/leurovisiu.jpg'
import workout from './images/workout.jpg'
import appAG from './images/altaguardia.jpg'

const mockData =[
    {
        title: "L'Eurovisiu",
        image: leurovisiu,
        link: "https://glezarts.github.io/revista-online/",
    },
    {
        title: "Workout Web",
        image: workout,
        link: "https://glezarts.github.io/maquetacion_workout/"
    },
    {
        title: 'App Alta Guardia',
        image: appAG,
        link:''
    }
]

export default mockData;